import { styled } from '@mui/material/styles';
import Box, { type BoxProps } from '@mui/material/Box';

const BetaBadgeRoot = styled(Box)({
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const BetaBadgeLabel = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  lineHeight: 1.2,
  display: 'block',
}));

export const BetaBadge = (props: BoxProps) => (
  <BetaBadgeRoot {...props}>
    <BetaBadgeLabel>Beta</BetaBadgeLabel>
  </BetaBadgeRoot>
);
